<script setup lang="ts">
import type { DynamicDialogInstance } from 'primevue/dynamicdialogoptions';

const { t } = useI18n();

const dialogRef = inject<Ref<DynamicDialogInstance>>('dialogRef');

const upgrade = () => {
  dialogRef?.value.close();
  navigateTo('/pricing');
};

const close = () => {
  dialogRef?.value.close();
};

</script>

<template>
  <div class="max-w-lg">
    <h3 class="text-16">
      {{t('course.upsell.title')}}
    </h3>
    <p>
      {{t('course.upsell.featuresList.title')}}
    </p>
    <ul class="pl-4">
      <li class="mb-2">
        <b>{{t('course.upsell.featuresList.item1.bold')}}</b>{{t('course.upsell.featuresList.item1.text')}}
      </li>
      <li class="mb-2">
        {{t('course.upsell.featuresList.item2.textStart')}}<b>{{t('course.upsell.featuresList.item2.bold')}}</b>{{t('course.upsell.featuresList.item2.textEnd')}}
      </li>
      <li class="mb-2">
        {{t('course.upsell.featuresList.item3')}}
      </li>
      <li class="mb-2">
        <b>{{t('course.upsell.featuresList.item4.bold')}}</b>{{t('course.upsell.featuresList.item4.text')}}
      </li>
    </ul>
    <p>
      {{t('course.upsell.ctaText')}}
    </p>
    <div class="flex justify-end gap-4">
      <Button
        outlined
        severity="secondary"
        @click="close"
      >
        {{t('course.upsell.cancel')}}
      </Button>
      <Button
        class="bg-yellow-50 text-neutral-80 font-bold text-bold border-none text-nowrap"
        @click="upgrade"
      >
        {{t('course.upsell.upgrade')}}
      </Button>
    </div>
  </div>
</template>